import { z } from 'zod';

const decimalString = z.string().regex(/^-?\d+(\.\d+)?$/, 'invalidDecimal');

export const FixCashflowFormSchema = z.object({
  cashflow_id: z.string().trim().min(1, 'required'),
  rate: decimalString,
  index_name: z.string().trim().optional(),
  fixing_date: z.string().trim().optional(),
});

export type FixCashflowForm = z.infer<typeof FixCashflowFormSchema>;

export const CashflowResponseSchema = z.object({
  id: z.string(),
  deal_id: z.string(),
  leg_id: z.string().nullable().optional(),
  cashflow_type: z.string(),
  payment_date: z.string(),
  amount: decimalString,
  currency: z.string(),
  status: z.string(),
  fixing_rate: decimalString.nullable().optional(),
  day_count_fraction: decimalString.nullable().optional(),
  produced_by_artifact_id: z.string().nullable().optional(),
});

export type CashflowResponse = z.infer<typeof CashflowResponseSchema>;
